<template>
  <Row
    class="performance-link"
    left-title="Histórico de performance"
    left-subtitle="Mensal e anual"
    :has-line="false"
    data-testid="performance-link"
    chevron
    has-interaction
    @click="handleClick"
  >
    <template #icon-left>
      <InitialAvatarIcon
        class="performance-link__icon"
        icon="ED0100"
        size="medium"
      />
    </template>
  </Row>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router/composables';

import { Row, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';

interface Props {
  portfolioId: string;
}
const props = defineProps<Props>();

const router = useRouter();

const handleClick = () => {
  router.push({
    name: 'wealthPerformanceV2',
    params: { portfolioId: props.portfolioId }
  });
};
</script>

<style lang="less" scoped>
.performance-link {
  margin-top: @size-spacing-x600;

  &__icon {
    color: @element-primary;
    background-color: @background-tertiary;
  }
}
</style>
